function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_466_"
}, /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_467_",
  x: 170,
  y: 259.609,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_468_",
  x: 90,
  y: 259.609,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_469_",
  x: 50,
  y: 259.609,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_470_",
  x: 130,
  y: 259.609,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_472_",
  x: 250,
  y: 259.609,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_473_",
  x: 210,
  y: 259.609,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_474_",
  d: "M150,115.4c0-41.36-33.646-75.009-75.001-75.009C33.644,40.391,0,74.04,0,115.4 c0,67.33,64.064,109.981,66.792,111.764c2.493,1.629,5.351,2.444,8.207,2.444c2.856,0,5.714-0.815,8.208-2.444 c0.355-0.233,8.858-5.825,19.521-15.76C124.294,191.316,150,158.354,150,115.4z M75,135.391c-11.045,0-20.001-8.954-20.001-19.999 c0-11.046,8.956-20.001,20.001-20.001c11.044,0,19.999,8.955,19.999,20.001C94.999,126.437,86.044,135.391,75,135.391z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_477_",
  d: "M254.999,40.391C213.644,40.391,180,74.04,180,115.4c0,67.33,64.064,109.981,66.792,111.764 c2.493,1.629,5.351,2.444,8.207,2.444c2.857,0,5.714-0.815,8.208-2.444c0.355-0.233,8.858-5.825,19.521-15.76 C304.294,191.316,330,158.354,330,115.4C330,74.04,296.354,40.391,254.999,40.391z M255,135.391 c-11.045,0-20.001-8.954-20.001-19.999c0-11.046,8.956-20.001,20.001-20.001c11.044,0,19.999,8.955,19.999,20.001 C274.999,126.437,266.044,135.391,255,135.391z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgKm = function SvgKm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 330",
    style: {
      enableBackground: "new 0 0 330 330"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Km.aac5a8a8.svg";
export { ForwardRef as ReactComponent };